import { TCreateContactTypeReqDto } from "@/api/services/contact-type/dtos/create-contact-type.dto";
import { TGetContactTypeDto } from "@/api/services/contact-type/dtos/get-contact-type.dto";
import { TUpdateContactTypeReqDto } from "@/api/services/contact-type/dtos/update-contact-type.dto";
import { CONTACT_TYPE } from "@/constants/enum";
import { TContactTypeForm } from "@/features/contact/types/contactTypeForm";

export const convertContactTypeFormToCreateReq = (data: TContactTypeForm, isCompany: boolean): TCreateContactTypeReqDto => {
  return {
    ...data,
    name: data.name,
    template: data.template ?? "",
    email: data.email,
    type: isCompany ? CONTACT_TYPE.COMPANY : CONTACT_TYPE.RSO,
  };
};

export const convertContactTypeFormToUpdateReq = (data: TContactTypeForm, isCompany: boolean): TUpdateContactTypeReqDto => {
  return {
    ...data,
    name: data.name,
    template: data.template,
    email: data.email,
    type: isCompany ? CONTACT_TYPE.COMPANY : CONTACT_TYPE.RSO,
  };
};

export const convertContactTypeResToForm = (data: TGetContactTypeDto): TContactTypeForm => {
  return {
    name: data.name,
    template: data.template,
    email: data.email,
  };
};
